module.exports = __webpack_public_path__ + "static/img/avatar.90234ccd.png";